package app.bloomey.web.core.data.models

import kotlinx.serialization.Serializable

enum class Precision {
    day, week, month,
}

@Serializable
data class TimeSeriesQuery(
    val precision: Precision,
    val value: Int,
)